import { ColumnConfig, ColumnDataType } from '@aurora';

export const chartVariableColumnsConfig: ColumnConfig[] = [
    {
        type: ColumnDataType.STRING,
        field: 'displayName',
        sort: 'displayName',
        translation: 'digitai.DisplayName',
        isUnaccent: true,
    },
    {
        type: ColumnDataType.STRING,
        field: 'variableName',
        sort: 'variableName',
        translation: 'digitai.VariableName',
        isUnaccent: true,
    },
];
